
<div :class="jel_getClassObject(content)" class="menuBas px-md-2">
  <Menu :content="content" class="text-center">
    <template #element="{ itemElement }">
      <div class="item" :class="{ 'menu-titre': itemElement.image }">
        <b-img-lazy
          v-if="itemElement.image"
          :src="jel_getFichierSrc(itemElement.image)"
          :alt="itemElement.item"
        />
        <div :class="{ 'padding-menu-bas': !itemElement.image }">
          {{ itemElement.item }}
        </div>
      </div>
    </template>
  </Menu>
</div>
